import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Dashboard from './dashboard/Dashboard';
import CoursesPage from './pages/CoursesPage';
import CourseDetailsPage from './pages/CourseDetailsPage';
import CoursesAdminDashboardPage from './pages/CoursesAdminDashboardPage';
import CoursesUserSubmissionsPage from './pages/CoursesUserSubmissionsPage';
import CommunityAdminDashboardPage from './pages/CommunityAdminDashboardPage';
import SignInSide from './sign-in-side/SignInSide';
import SignUp from './sign-up/SignUp';
import CommunityPage from './pages/CommunityPage';
import ThreadPage from './pages/ThreadPage'; // Import ThreadPage
import TopicThreadsPage from './pages/TopicThreadsPage';
import UserActivityPage from './pages/UserActivityPage';
import TutorsPage from './pages/TutorsPage';
import TutorProfilePage from './pages/TutorProfilePage';
import BookSessionPage from './pages/BookSessionPage';
import BookLessonPage from './pages/BookLessonPage';
import RequireAuth from './components/RequireAuth';
import SettingsPage from './pages/SettingsPage';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import FeedbackPage from './pages/FeedbackPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import VerifyEmailSentPage from './pages/VerifyEmailSentPage';
import ResetPasswordConfirmPage from './pages/ResetPasswordConfirmPage';

const App = () => {
  return (
    <Router>
        <Dashboard>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/courses/:id" element={
              <RequireAuth><CourseDetailsPage /></RequireAuth>
            } />
            <Route path="/courses/admin-dashboard" element={
              <RequireAuth><CoursesAdminDashboardPage /></RequireAuth>
            } />
            <Route path="/courses/my-submissions" element={<CoursesUserSubmissionsPage />} />
            <Route path="/sign-in" element={<SignInSide />} />
            <Route path="/sign-up" element={<SignUp />} />
            <Route path="/verify-email" element={<VerifyEmailPage />} />
            <Route path="/verify-email-sent" element={<VerifyEmailSentPage />} />
            <Route path="/reset/:uid/:token/" element={<ResetPasswordConfirmPage />} />
            <Route path="/community" element={<CommunityPage />} />
            <Route path="/community/admin-dashboard" element={
              <RequireAuth><CommunityAdminDashboardPage /></RequireAuth>
            } />
            <Route path="/community/threads/:threadId" element={<ThreadPage />} />
            <Route path="/community/topic/:topicName" element={<TopicThreadsPage />} />
            <Route path="/community/user/:displayName" element={<UserActivityPage />} />
            <Route path="/tutors" element={
              <RequireAuth><TutorsPage /></RequireAuth>
            } />
            <Route path="/tutors/:id" element={
              <RequireAuth><TutorProfilePage /></RequireAuth>
            } />
            <Route path="/tutors/book/:rateId" element={
              <RequireAuth><BookSessionPage /></RequireAuth>
            } />
            <Route path="/tutors/book" element={
              <RequireAuth><BookLessonPage /></RequireAuth>
            } />
            <Route path="/settings" element={
              <RequireAuth><SettingsPage /></RequireAuth>
            } />
            <Route path="/feedback" element={
              <RequireAuth><FeedbackPage /></RequireAuth>
            } />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          </Routes>
        </Dashboard>
      </Router>
  );
};

export default App;
